import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-player-page" }
const _hoisted_2 = { class: "mb-4 flex justify-between" }
const _hoisted_3 = { class: "text-subtitle-1 text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_VideoPlayer = _resolveComponent("VideoPlayer", true)!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/nice",
        class: "bg-blue-100 text-blue-700 hover:bg-blue-200 px-4 py-2 rounded flex items-center"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "bi-arrow-left mr-2" }, null, -1),
          _createTextVNode(" Zurück zur Videodeduplikation ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('media.videoPlayer.title')) + " ", 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.clientId), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_VideoPlayer, {
              "client-id": _ctx.clientId,
              width: "100%",
              height: "480px"
            }, null, 8, ["client-id"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}